module.exports = __webpack_public_path__ + "media/icons/circle-check-green-f03282e4.svg";